module.exports = __webpack_public_path__ + "static/energy_private_12-b3d4c648ec8cc4843ac1ab5506942ba0.jpg";